import {useEffect, useState} from 'react'
import styles from '../../sass/components/ModuleCard.module.scss'
require('@/Utilities/TestId');

export default function ModuleCard({module, interactive = true, hoverable= true, startingState = false, toggleModules, showCheck = true, useModuleSalesName = false, useModuleBackgroundHoverColor = false }) {
    let [selected, updatedSelected] = useState(startingState);
    let [hovered, updatedHovered] = useState(false);

    useEffect(() => {
        updatedSelected(startingState);
    }, [startingState])

    return (
        <div data-testid={"module_card-div-"+parseStringToTestId(module.name)}>
            <input onChange={toggleSelected} id={module.uuid} className="btn-check" type="checkbox" name="modules[]"
                   checked={isSelected()}/>
            <label
                onMouseEnter={() => isHoverable() && updatedHovered(true)}
                onMouseLeave={() => isHoverable() && updatedHovered(false)}
                className={`${styles.card} ${isHoverable() ? styles.interactive : ''} `}
                style={{
                    outlineColor:  isSelected() ? (isSelectedOrHovered() ? module.colors.color : '') : (''),
                    outlineWidth: isSelected() ? (isSelectedOrHovered() ? '2px' : '') : (''),
                    outlineStyle: isSelected() ? (isSelectedOrHovered() ? 'solid' : '') : (''),
                    backgroundColor: useModuleBackgroundHoverColor ? (isSelectedOrHovered() ? module.colors.background : '') : (''),
                    cursor: !isHoverable() ? 'default' : ''
                }}
                htmlFor={module.uuid}
            >
                <span
                    className={`${ (isSelected() && showCheck) ? styles.checkIcon : styles.hideCheckIcon}`}
                    style={{color: module.colors.color}}
                >
                    <i className="fa fa-solid fa-check"
                        data-testid={
                            `${ (isSelected() && showCheck) ? "module_card-i-"+parseStringToTestId(module.name)+"_checked" : "module_card-i-"+parseStringToTestId(module.name)+"_unchecked"}`
                        }
                    ></i>
                </span>
                <div
                    className={styles.wrap}
                >
                    <div className={styles.iconContainer}>
                        <div
                            className={styles.icon}
                            style={{color: module.colors.border}}
                            dangerouslySetInnerHTML={{__html: module.tile ?? module.icon }}
                        ></div>
                        <div className={styles.nameContainer}>
                            <div data-testid={"module_card-labeldiv"} className={styles.name} dangerouslySetInnerHTML={{__html: useModuleSalesName ? module.sales_name ?? module.name : module.name}}></div>
                        </div>
                    </div>
                </div>
            </label>
        </div>
    );


    function isSelectedOrHovered() {
        return isSelected() || isHovered();
    }

    function isInteractive() {
        return interactive;
    }

    function isHoverable() {
        return hoverable;
    }

    function isSelected() {
        return selected;
    }

    function isHovered() {
        return hovered;
    }

    function toggleSelected() {
        if (!isInteractive()) {
            return
        }
        let updated = !selected;
        updatedSelected(updated)
        toggleModules();
    }
}
